var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"response"},[_c('div',{staticClass:"service-container"},[_c('RichText',{ref:"richTextViewRef",attrs:{"id":_vm.id}}),_c('ServeList',{ref:"serveListViewRef"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }